import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfirmProvider, ToasterProvider } from '@smworks-cz/ui-kit';
import { App } from './App';
import { queryClient } from './lib/queries';
import { applyTheme, storedTheme } from './lib/theme';
import { initPwa } from './lib/pwa';
import './styles.css';

applyTheme(storedTheme());
initPwa();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToasterProvider position="bottom-right">
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ToasterProvider>
    </QueryClientProvider>
  </StrictMode>,
);
